import {kr, pct} from '../lib/format.js';

/**
 * Each card names its SOURCE. That is not decoration: MRR comes from the invoice
 * register, which is complete through August, while margin, cost and result come
 * from the ledger, which is only complete through July. A row of eight figures that
 * silently mixed the two would be the most misleading thing on the page.
 */
export default function Cards({kpi}) {
	const dMrr = kpi.mrr - (kpi.mrr_prev ?? kpi.mrr);
	const cards = [
		['MRR', `${kr(kpi.mrr)} kr`, `${dMrr >= 0 ? '+' : ''}${kr(dMrr)} mot föregående`, 'faktura'],
		['ARR', `${kr(kpi.arr)} kr`, 'MRR × 12', 'faktura'],
		['Kunder', kpi.customers, `${kr(kpi.arpa)} kr ARPA`, 'faktura'],
		['NRR', pct(kpi.nrr), `GRR ${pct(kpi.grr)}`, 'faktura'],
		['Likvida medel', `${kr(kpi.cash)} kr`, `per ${kpi.cash_month}`, 'huvudbok'],
		['Burn', `${kr(kpi.burn)} kr/mån`, 'snitt tre bokförda månader', 'huvudbok'],
		['Runway', kpi.runway == null ? '—' : `${kpi.runway} mån`, 'vid oförändrad burn', 'huvudbok', true],
		['Bruttomarginal', pct(kpi.gross_margin), `per ${kpi.ledger_month}`, 'huvudbok'],
	];
	return (
		<div className="cards">
			{cards.map(([label, value, hint, src, adjusted]) => (
				<div className="card" key={label}>
					<span className="card__label"><span className="card__src">{src}</span>{label}</span>
					<div className="card__value">{value}</div>
					<div className={`card__hint${adjusted ? ' card__hint--adjusted' : ''}`}>{hint}</div>
				</div>
			))}
		</div>
	);
}
